var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.12,
    height: 40.037,
    viewBox: "0 0 37.12 40.037",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checklist-minimalistic-svgrepo-com_1_",
    "data-name": "checklist-minimalistic-svgrepo-com (1)",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7082",
    "data-name": "Path 7082",
    d: "M2,21.269C2,12.185,2,7.644,4.608,4.822S11.414,2,19.81,2,32.4,2,35.012,4.822s2.608,7.363,2.608,16.447,0,13.625-2.608,16.447-6.806,2.822-15.2,2.822-12.594,0-15.2-2.822S2,30.352,2,21.269Z",
    transform: "translate(-2 -2)",
    fill: "none",
    stroke: "#19af4b",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7083",
    "data-name": "Path 7083",
    d: "M6,17.206l2.035,2.137L13.124,14",
    transform: "translate(1.124 9.431)",
    fill: "none",
    stroke: "#19af4b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7084",
    "data-name": "Path 7084",
    d: "M6,10.206l2.035,2.137L13.124,7",
    transform: "translate(1.124 2.763)",
    fill: "none",
    stroke: "#19af4b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7085",
    "data-name": "Path 7085",
    d: "M13,9h8.905",
    transform: "translate(6.591 4.488)",
    fill: "none",
    stroke: "#19af4b",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7086",
    "data-name": "Path 7086",
    d: "M13,16h8.905",
    transform: "translate(6.591 10.976)",
    fill: "none",
    stroke: "#19af4b",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.21f5e8ec99e885dd9cb0d102c424b8e9.svg";
export { ForwardRef as ReactComponent };